import { getFingerprint } from "helpers/services/fingerprint";
import { useEffect, useState } from "react";

const isBrowser = typeof window !== "undefined";

export function useFingerprint() {
  const [fingerprint, setFingerprint] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!isBrowser) {
      setIsLoading(false);
      return;
    }

    (async () => {
      try {
        setIsLoading(true);
        setError(null);

        const fp = await getFingerprint();
        setFingerprint(fp);
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error("Unknown fingerprint error")
        );
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return {
    fingerprint,
    isLoading,
    error,
  };
}
